import '@rmwc/menu/styles';
import {MenuItem as RMWCMenuItem} from '@rmwc/menu';

const MenuItem = (
  props: React.ComponentPropsWithRef<typeof RMWCMenuItem>,
): React.JSX.Element => {
  return <RMWCMenuItem {...props} />;
};

export {MenuItem};
